const addaddress = {
  namespaced: true,
  state: {
    receiver: ``,
    password: ``,
  },
  mutations: {
    setReceiver(state, receiver) {
      state.receiver = receiver;
    },
    serpassword(state, password) {
      state.password = password;
    },
    getReceiver(state, val1) {
      if (val1) {
        state.receiver = val1;
      }
    },
  },
  actions: {
    upReceiver(context, val) {
      context.commit('getReceiver', val);
    },
  },
};
export default addaddress;
